import api from "config/axios";

export const getSeasonList = () => api.get("/seasons");
export const getSeason = (id) => api.get(`/seasons/${id}`);
